import { Pagination } from '@store/common/pagination.model';
import { TableFilter, TableFilterType } from '@store/common/tableFilter.model';
import I18n from '@utils/i18n.utils';

export interface ManageHistory {
  id?: number;
  ressourceId?: number;
  tableName?: string;
  authorId?: number;
  eventType?: HistoryType;
  previousValue?: string;
  newValue?: string;
}

export interface HistoryFilters {
  search: string;
  tableFilters: TableFilter[];
  fromDate?: Date;
  toDate?: Date;
}

export namespace HistoryFilters {
  export const initTableFilters = (authorId?: string) =>
    TableFilterType.initTableFilters([TableFilterType.TYPE_ACTION, TableFilterType.USER]).map((f) => ({
      ...f,
      hide: f.type === TableFilterType.USER && !!authorId,
      values: f.type === TableFilterType.USER && !!authorId ? [{ label: '', value: authorId }] : [],
    }));
}

export interface HistoryPagination extends Pagination {
  data: History[];
}

export enum HistoryType {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  DOWNLOAD = 'DOWNLOAD',
  SEND = 'SEND'
}

export namespace HistoryType {
  export const selectItems = () => [
    { label: I18n.t('global.historyType.create'), value: HistoryType.CREATE },
    { label: I18n.t('global.historyType.update'), value: HistoryType.UPDATE },
    { label: I18n.t('global.historyType.delete'), value: HistoryType.DELETE },
    { label: I18n.t('global.historyType.download'), value: HistoryType.DOWNLOAD },
    { label: I18n.t('global.historyType.send'), value: HistoryType.SEND },
  ];
}

export namespace HistoryType {
  export const selectItemsCompare = () =>
    [
      { label: I18n.t('global.historyType.create'), value: HistoryType.CREATE },
      { label: I18n.t('global.historyType.update'), value: HistoryType.UPDATE },
      { label: I18n.t('global.historyType.delete'), value: HistoryType.DELETE },
    ].sort((a, b) => a.label.localeCompare(b.label));
}

export interface History {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  ressourceId: number;
  tableName: string;
  authorId: number;
  authorFirstName: string;
  authorLastName: string;
  eventType: HistoryType;
  previousValue: string;
  newValue: string;
}
